import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CheckBoxComponent } from '@shared/components/checkbox/checkbox.component';
import { InfoCardComponent } from '@shared/components/info-card/info-card.component';

@Component({
  selector: 'app-zubuchbar-card',
  imports: [CheckBoxComponent, CheckBoxComponent, TranslateModule, InfoCardComponent, CommonModule],
  templateUrl: './zubuchbar-card.component.html',
  styleUrl: './zubuchbar-card.component.scss',
})
export class ZubuchbarCardComponent {
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() text: string = '';
  @Input() infoText: TemplateRef<any>;
  @Input() checkboxFormControl;
  @Input() checkboxDisabled;
  @Input() showAdditionalCheckbox: boolean = false;
  @Input() disabled: boolean = false;
}
